import React, { useState } from "react";
import Icon, {
    IconPlusCircle,
    IconExclamationCircle,
} from "../../../../../common-deprecated/styles/v2/lexus/globals/Icon";
import { IconWrapper } from "../../../../../common-deprecated/styles/v2/lexus/globals/IconWrapper";
import type { EquipmentSpecNameIdValueType } from "../../../../../common-deprecated/features/compare/utils/newCarCompareTypes";
import * as Button from "../../../../../common-deprecated/styles/v2/lexus/components/Button";
import ColourSpecValuePopup from "../../common/highlight/content/ColourSpecValuePopup";
import { useCompareV2Selector } from "../../../redux/store";

type CompareEquipmentOrSpecValuePropsType = {
    value: EquipmentSpecNameIdValueType;
    carColour?: string;
};

// TO DO: update icons
const EquipmentOrSpecValue = (props: CompareEquipmentOrSpecValuePropsType): JSX.Element => {
    const cars = useCompareV2Selector(({ newCarCompare }) => newCarCompare.grades);

    const { value, carColour } = props;
    const [showPopup, setShowPopup] = useState<boolean>(false);

    switch (value.value) {
        case "s":
            // This equipment item is standard, but can be not applicable for certain colours, we check that first:
            if (carColour && value.colours && value.colours.length && !value.colours.includes(carColour)) {
                return (
                    <>
                        <IconWrapper iconColor="midnight">
                            <Icon variant="minus" />
                        </IconWrapper>
                        <Button.Icon
                            onClick={() => {
                                setShowPopup(!showPopup);
                            }}
                        >
                            <IconWrapper iconColor="midnight">
                                <IconExclamationCircle data-testid="iconExclamationCircle" />
                            </IconWrapper>
                        </Button.Icon>
                        {showPopup && (
                            <ColourSpecValuePopup
                                content={
                                    <>
                                        {value.colours.map((c) => {
                                            const colourName = cars.map(
                                                (grade) =>
                                                    grade.availableColours?.find((color) => color.code === c)?.name,
                                            );

                                            return (
                                                <p key={c}>
                                                    {colourName}
                                                    <IconWrapper iconColor="success">
                                                        <Icon variant="check" />
                                                    </IconWrapper>
                                                </p>
                                            );
                                        })}
                                    </>
                                }
                                closePopup={() => {
                                    setShowPopup(false);
                                }}
                            />
                        )}
                    </>
                );
            }
            return (
                <IconWrapper iconColor="success">
                    <Icon variant="check" />
                </IconWrapper>
            );
        case "o":
            // This equipment item is optional, but can be not applicable for certain colours, we check that first:
            if (carColour && value.colours && value.colours.length && !value.colours.includes(carColour)) {
                return (
                    <>
                        <IconWrapper iconColor="midnight">
                            <Icon variant="minus" />
                        </IconWrapper>
                        <Button.Icon
                            onClick={() => {
                                setShowPopup(!showPopup);
                            }}
                        >
                            <IconWrapper iconColor="midnight">
                                <IconExclamationCircle data-testid="iconExclamationCircle" />
                            </IconWrapper>
                        </Button.Icon>
                        {showPopup && (
                            <ColourSpecValuePopup
                                content={
                                    <>
                                        {value.colours.map((c) => {
                                            const colourName = cars.map(
                                                (grade) =>
                                                    grade.availableColours?.find((color) => color.code === c)?.name,
                                            );

                                            return (
                                                <p key={c}>
                                                    {colourName}
                                                    <IconWrapper iconColor="midnight">
                                                        <Icon variant="customize" />
                                                    </IconWrapper>
                                                </p>
                                            );
                                        })}
                                    </>
                                }
                                closePopup={() => {
                                    setShowPopup(false);
                                }}
                            />
                        )}
                    </>
                );
            }
            return (
                <IconWrapper iconColor="midnight">
                    <Icon variant="customize" />
                </IconWrapper>
            );
        case "op":
            // This equipment is not available as standard, not optional on its own but it is only available in optional pack.
            return (
                <IconWrapper>
                    <IconPlusCircle />
                </IconWrapper>
            );
        case "":
            return (
                <IconWrapper iconColor="midnight">
                    <Icon variant="minus" />
                </IconWrapper>
            );
        default:
            return <>{value.value}</>;
    }
};

export default EquipmentOrSpecValue;
